var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33268 1.83337V4.50004C9.33268 4.85366 9.47316 5.1928 9.72321 5.44285C9.97326 5.6929 10.3124 5.83337 10.666 5.83337H13.3327M13.3327 11.8334L12.4687 10.9694C12.1674 10.6681 11.7588 10.4989 11.3327 10.4989C10.9066 10.4989 10.498 10.6681 10.1967 10.9694L5.99935 15.1667M9.99935 1.83337H3.99935C3.64573 1.83337 3.30659 1.97385 3.05654 2.2239C2.80649 2.47395 2.66602 2.81309 2.66602 3.16671V13.8334C2.66602 14.187 2.80649 14.5261 3.05654 14.7762C3.30659 15.0262 3.64573 15.1667 3.99935 15.1667H11.9993C12.353 15.1667 12.6921 15.0262 12.9422 14.7762C13.1922 14.5261 13.3327 14.187 13.3327 13.8334V5.16671L9.99935 1.83337ZM7.99935 8.50004C7.99935 9.23642 7.4024 9.83337 6.66602 9.83337C5.92964 9.83337 5.33268 9.23642 5.33268 8.50004C5.33268 7.76366 5.92964 7.16671 6.66602 7.16671C7.4024 7.16671 7.99935 7.76366 7.99935 8.50004Z",
    stroke: "#828FAB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileImage);
export default __webpack_public_path__ + "static/media/file-image.a89ad9646901f400150c4ef0459c2a99.svg";
export { ForwardRef as ReactComponent };